import i18n from "../../../../Utils/i18next/i18next";
import store from "../../../../store";
import { NotificationManager } from "react-notifications";
import { GlobalAuthFetch } from "../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import { cloneDeep } from "lodash";

const { t } = i18n;

export const onSubmit = async (values, props) => {
  const { contractReducer } = store.getState();
  const { updateTableRegistry, loadData, update, updateSingleRegistry, uuid } =
    props;

  const data = cloneDeep({
    ...values,
    representative: values.representative?.value
      ? { uuid: values.representative?.value }
      : null,
    contractType: { uuid: values.contractType?.value },
  });

  let payload;

  if (!update) {
    data.status = contractReducer?.availableStatuses.find(
      (el) => !!el.isSelected
    );

    const res = await GlobalAuthFetch({
      path: `/contract`,
      method: "POST",
      data,
    });
    payload = res.payload;
  }

  if (update) {
    const res = await GlobalAuthFetch({
      path: `/contract/${uuid}`,
      method: "PATCH",
      data,
    });
    payload = res.payload;
  }

  if (payload?.status >= 300 || !payload?.status) {
    props.setErrorHeader(0, true);

    return;
  }

  props.setErrorHeader(0, false);

  //Succes nofify
  loadData();
  NotificationManager.success(i18n.t("global:success"));
  if (updateSingleRegistry) updateSingleRegistry();
  if (updateTableRegistry) updateTableRegistry();
  props.handleHide();
};

export const onValidate = (values, props) => {
  // const { update } = props;
  const errorsStep0 = {};

  if (!values.numberContract) {
    errorsStep0.numberContract = t("global:contract.errors.numberContract");
  }
  if (!values.signDate) {
    errorsStep0.signDate = t("global:contract.errors.signDate");
  }
  if (!values.title) {
    errorsStep0.title = t("global:contract.errors.title");
  }
  if (!values.contractType) {
    errorsStep0.contractType = t("global:contract.errors.contractType");
  }
  if (!values.contact) {
    errorsStep0.contact = t("global:contract.errors.contact");
  }

  if (
    !props.steps[0]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep0).length > 0
  ) {
    props.setErrorHeader(0, true);
  }
  if (
    !!props.steps[0]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep0).length <= 0
  ) {
    props.setErrorHeader(0, false);
  }

  return { ...errorsStep0 };
};
